var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1910",
    "data-name": "Groupe 1910",
    transform: "translate(0.017 0.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance_wallet_FILL0_wght400_GRAD0_opsz48",
    d: "M7.433,21.288v0Zm0,2.846a1.355,1.355,0,0,1-.991-.453A1.468,1.468,0,0,1,6,22.623V7.511a1.483,1.483,0,0,1,.442-1.045A1.339,1.339,0,0,1,7.433,6h14.33a1.326,1.326,0,0,1,1,.466,1.5,1.5,0,0,1,.43,1.045v3.375H21.763V7.511H7.433V22.623h14.33v-3.35H23.2v3.35a1.489,1.489,0,0,1-.43,1.058,1.342,1.342,0,0,1-1,.453Zm8.55-4.357a1.693,1.693,0,0,1-1.29-.5,1.86,1.86,0,0,1-.478-1.335V12.221a1.85,1.85,0,0,1,.478-1.347,1.716,1.716,0,0,1,1.29-.491h6.449a1.716,1.716,0,0,1,1.29.491,1.85,1.85,0,0,1,.478,1.347v5.717a1.86,1.86,0,0,1-.478,1.335,1.693,1.693,0,0,1-1.29.5Zm6.783-1.511V11.894H15.649v6.372Z",
    transform: "translate(-2.472 -3.015)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    width: 24,
    height: 24,
    transform: "translate(-0.017 -0.017)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.bd7602838589fb6b769047c118e010b6.svg";
export { ForwardRef as ReactComponent };